import moment from "moment";
import React, {Component, Fragment} from "react";
import {withTranslation} from "react-i18next";
import Select from "react-select";
import {MAX_MONTH_RANGE} from "../../constant";
import DatePicker from "react-datepicker";
import {faSearch, faUndo} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const DATE_RANGE_ERROR_MESSAGE = `Date range must not be more than ${MAX_MONTH_RANGE} months`
const DATE_FORMAT = "dd/MM/yyyy";

const DOCUMENT_STATUS_LIST = [
  { label: "Uploaded", value: "UPLOADED" },
  { label: "Not Uploaded", value: "NOT_UPLOADED" },
  { label: "Removed", value: "REMOVED" }
];

const KYC_LEVEL_LIST = [
  { label: "N/A", value: "N/A" },
  { label: "F", value: "F" },
  { label: "F2", value: "F2" }
];

const initialState = {
  branchIds: "",
  transactionStartDate: moment().subtract(1, "day").toDate().setMilliseconds(0),
  transactionEndDate: moment().toDate().setMilliseconds(0),
  maxDate: moment().toDate(),
  identity: "",
  workPermitId: "",
  customerName: "",
  selectedDocumentTypes: [],
  selectedKycLevels: [],
  showError: false,
  errorMsg: "",
};

class KycProfileSearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  monthRangeIsMoreThanMaxMonthRange = (from, to) => {
    const monthDiff = to.diff(from, "months", true);
    return monthDiff > MAX_MONTH_RANGE;
  };

  onClearHandler = (event) => {
    event.preventDefault();
    const { onClear } = this.props;
    this.setState(initialState);

    if (onClear) {
      onClear();
    }
  };

  onSubmitHandler = (event) => {
    event.preventDefault();

    const from = moment(this.state.transactionStartDate);
    const to = moment(this.state.transactionEndDate);

    if (this.monthRangeIsMoreThanMaxMonthRange(from, to)) {
      this.setState({
        showError: true,
        errorMsg: DATE_RANGE_ERROR_MESSAGE
      });
    } else if (!this.state.showError) {
      const params = Object.assign({}, this.state);
      this.props.onSubmit(params);
    }
  };

  onChangeHandler = (event) => {
    this.setState({
      [event.target.name]:
        event.target.name === "identity"
          ? event.target.value.toUpperCase()
          : event.target.value,
    });
  };

  onChangeDocumentTypeHandler = (selectedDocumentTypes) => {
    this.setState({
      selectedDocumentTypes: selectedDocumentTypes,
    });
  };

  onChangeKycLevelHandler = (selectedKycLevels) => {
    this.setState({
      selectedKycLevels: selectedKycLevels,
    });
  };

  onChangeStartDate = (transactionStartDate) => {
    let showError = false;
    let errorMsg = "";

    if (!transactionStartDate) {
      showError = true;
      errorMsg = "Transaction start date is required";
    } else {
      const from = moment(transactionStartDate);
      const to = moment(this.state.transactionEndDate);

      if (from.isAfter(to)) {
        showError = true;
        errorMsg = "End date must not be less than start date";
      } else {
        if (this.monthRangeIsMoreThanMaxMonthRange(from, to)) {
          showError = true;
          errorMsg = DATE_RANGE_ERROR_MESSAGE;
        }
      }
    }

    this.setState({
      transactionStartDate: transactionStartDate,
      showError: showError,
      errorMsg: errorMsg,
    });
  };

  onChangeEndDate = (transactionEndDate) => {
    let showError = false;
    let errorMsg = "";

    if (!transactionEndDate) {
      showError = true;
      errorMsg = "Transaction end date is required";
    } else {
      const from = moment(this.state.transactionStartDate);
      const to = moment(transactionEndDate);

      if (to.isBefore(from)) {
        showError = true;
        errorMsg = "Start date must not be more than end date";
      } else {
        if (this.monthRangeIsMoreThanMaxMonthRange(from, to)) {
          showError = true;
          errorMsg = DATE_RANGE_ERROR_MESSAGE;
        }
      }
    }

    this.setState({
      transactionEndDate: transactionEndDate,
      showError: showError,
      errorMsg: errorMsg,
    });
  };

  render() {
    const { t, disable } = this.props;
    const { errorMsg, showError } = this.state;
    return (
      <Fragment>
        <div className="card-body form-search form-horizontal">
          <div className="row">
            <div className="col-sm-3">
              <label>Transaction Start Date</label>
              <DatePicker
                  className="form-control"
                  allowSameDay
                  dateFormat={DATE_FORMAT}
                  maxDate={this.state.maxDate}
                  selected={this.state.transactionStartDate}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText={DATE_FORMAT.toUpperCase()}
                  onChange={this.onChangeStartDate}
              />
              <label hidden={!showError}>
                <span style={{ color: "red" }}>{errorMsg}</span>
              </label>
            </div>
            <div className="col-sm-3">
              <label>End Date</label>
              <DatePicker
                  className="form-control"
                  allowSameDay
                  dateFormat={DATE_FORMAT}
                  maxDate={this.state.maxDate}
                  selected={this.state.transactionEndDate}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText={DATE_FORMAT.toUpperCase()}
                  onChange={this.onChangeEndDate}
              />
              <label hidden={!showError}>
                <span style={{ color: "red" }}>{errorMsg}</span>
              </label>
            </div>
            <div className="col-sm-3">
              <label>{t("kyc-profile.search branch id")}</label>
              <input
                  type="text"
                  name="branchIds"
                  value={this.state.branchIds}
                  onChange={this.onChangeHandler}
                  className="form-control"
              />
            </div>
            <div className="col-sm-3">
              <label>{t("kyc-profile.search identity")}</label>
              <input
                  type="text"
                  name="identity"
                  maxLength="20"
                  value={this.state.identity}
                  onChange={this.onChangeHandler}
                  className="form-control"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label>{t("kyc-profile.search work permit id")}</label>
              <input
                  type="text"
                  name="workPermitId"
                  maxLength="20"
                  value={this.state.workPermitId}
                  onChange={this.onChangeHandler}
                  className="form-control"
              />
            </div>
            <div className="col-sm-3">
              <label>{t("kyc-profile.search customer name")}</label>
              <input
                  type="text"
                  name="customerName"
                  maxLength="100"
                  value={this.state.customerName}
                  onChange={this.onChangeHandler}
                  className="form-control"
              />
            </div>
            <div className="col-sm-3">
              <label htmlFor="document">{t("kyc-profile.search document status")}</label>
              <Select
                  inputId="document"
                  options={DOCUMENT_STATUS_LIST}
                  closeMenuOnSelect={false}
                  value={this.state.selectedDocumentTypes}
                  isMulti={true}
                  className="basic-multi-select text-lg-left"
                  onChange={this.onChangeDocumentTypeHandler}
              />
            </div>
            <div className="col-sm-3">
              <label htmlFor="kyc-level">{t("kyc-profile.search kyc level")}</label>
              <Select
                  inputId="kyc-level"
                  options={KYC_LEVEL_LIST}
                  closeMenuOnSelect={false}
                  value={this.state.selectedKycLevels}
                  isMulti={true}
                  className="basic-multi-select text-lg-left"
                  onChange={this.onChangeKycLevelHandler}
              />
            </div>
          </div>

          <div className="row">
            <div className="offset-sm-4 col-sm-2 text-lg-right">
              <button
                data-testid="button-kyc-search"
                name="submit"
                onClick={this.onSubmitHandler}
                className="btn btn-warning"
                disabled={disable}
              >
                <FontAwesomeIcon icon={faSearch} /> Search
              </button>
            </div>
            <div className="col-sm-2">
              <button
                data-testid="button-kyc-clear"
                className="btn btn-secondary"
                onClick={this.onClearHandler}
                disabled={disable}
                name="clear"
                type="button"
              >
                <FontAwesomeIcon icon={faUndo} /> Clear
              </button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withTranslation()(KycProfileSearchForm);
